import { useMemo, useState } from "react";
import { t } from "../i18n";
import { ChevronDown, Search } from "lucide-react";
import { countriesLocalized, countryName } from "../lib/data";
import { Flag } from "./Avatar";

export function CountrySelect({ value, onChange }) {
  const [open, setOpen] = useState(false);
  const [q, setQ] = useState("");
  const list = useMemo(() => {
    const n = q.trim().toLowerCase();
    const COUNTRIES = countriesLocalized();
    return n ? COUNTRIES.filter((c) => c.nombre.toLowerCase().includes(n) || c.iso.toLowerCase() === n) : COUNTRIES;
  }, [q]);

  return (
    <div>
      <label className="label">{t("common.country")}</label>
      <button type="button" data-testid="country-select-btn" onClick={() => setOpen((o) => !o)} className="field flex items-center gap-2 text-left">
        {value ? <><Flag iso={value} size={20} /> <span className="flex-1">{countryName(value)}</span></> : <span className="flex-1 text-muted-foreground">{t("person.selectCountry")}</span>}
        <ChevronDown size={18} className="text-muted-foreground" />
      </button>
      {open && (
        <div data-testid="country-select-list" className="mt-2 surface overflow-hidden">
          <div className="relative border-b border-border">
            <Search size={16} className="absolute left-3 top-1/2 -translate-y-1/2 text-muted-foreground" />
            <input autoFocus data-testid="country-search-input" className="w-full bg-transparent pl-9 pr-3 py-3 text-sm focus:outline-none" placeholder={t("person.searchCountry")} value={q} onChange={(e) => setQ(e.target.value)} />
          </div>
          <ul className="max-h-56 overflow-y-auto">
            {value && <li><button type="button" className="w-full text-left px-4 py-2.5 text-sm text-muted-foreground hover:bg-secondary" onClick={() => { onChange(""); setOpen(false); }}>{t("person.noCountry")}</button></li>}
            {list.map((c) => (
              <li key={c.iso}>
                <button type="button" data-testid={`country-option-${c.iso}`} onClick={() => { onChange(c.iso); setOpen(false); setQ(""); }}
                  className={`w-full text-left px-4 py-2.5 text-sm flex items-center gap-3 hover:bg-secondary ${c.iso === value ? "text-[#f3c649]" : ""}`}>
                  <Flag iso={c.iso} size={20} /> {c.nombre}
                </button>
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
}
